if (!customElements.get('outfit-products')) {
  class OutfitProducts extends HTMLElement {
    constructor() {
      super();

      this.outfitProducts = this.querySelectorAll('.outfit-product-block');

      this.submitBtn = this.querySelector('.add-to-cart-outfit-btn');
      this.submitBtn.addEventListener('click', this.addOutfitToCart.bind(this));

      this.querySelectorAll('[name="id"]').forEach((el) => {
        el.addEventListener('change', this.changeProductOption.bind(this));
      });

      this.productSelected = [];
    }

    async handleSectionsUpdateRequest(sectionIds){
      const sectionIdsStr = sectionIds.join(',')
      const response = await fetch(window.Shopify.routes.root + "?sections="+sectionIdsStr);
      const data = await response.json();
      return data;
    }

    async addOutfitToCart(evt){
      // console.log(evt);
      // if(this.validateProducts() && this.outfitProducts.length == this.productSelected.length){
      const outfitBlockCount = this.querySelectorAll('.outfit-product-block:not(.outfit-soldout-product)').length;
      if(this.validateProducts() && outfitBlockCount == this.productSelected.length){
        // console.log(this.productSelected);
        
        // Disable "Add to Cart" button until submission is complete.
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');

        const formData = new FormData();
        const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
        const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

        this.productSelected.forEach((obj) => {
          formData.append('items[][id]', obj.id);
          formData.append('items[][quantity]', obj.quantity);
          formData.append('items[][properties][__bundle]', this.dataset.productHandle);
          formData.append('items[][properties][Note]', this.dataset.product);
        });

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));
        
        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };

        try {
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          const data = await response.json();
          
          let error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map((item) => item[1].join(', '));
          }
          if (data.status) this.setErrorMsgState(error);
          if (!response.ok) throw new Error(response.status);
        
          if (document.querySelector('.template-cart')) {
            // Cart page
            const cartForm = document.querySelector('cart-form');
            if (cartForm && cartForm.enableAjaxUpdate) {
              cartForm.refresh();
            }
          } else if (theme.settings.afterAddToCart === 'page') {
            // Allow the tick animation to complete
            setTimeout(() => {
              window.location.href = theme.routes.cart;
            }, 300);
          } else {
            if(data.sections != null && Object.keys(data.sections).length > 0){
              // console.log('original');
              sectionsToUpdate.forEach((el) => {
                el.updateFromCartChange(data.sections[el.dataset.sectionId]);
              });
            }else{
              // console.log('custom coded');
              const sectionResponse = await this.handleSectionsUpdateRequest(sectionIds);
              // console.log(sectionResponse);
              if(Object.keys(sectionResponse).length > 0){
                sectionsToUpdate.forEach((el) => {
                  el.updateFromCartChange(sectionResponse[el.dataset.sectionId]);
                });
              }else{
                console.log('noresponse', sectionResponse);
              }
            }
            // sectionsToUpdate.forEach((el) => {
            //   el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            // });
        
            if (theme.settings.afterAddToCart === 'notification') {
              const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
              notification.dataset.productTitle = data.product_title;
              let notificationContainer = document.querySelector('.pageheader--sticky');
              if (!notificationContainer) {
                notificationContainer = document.querySelector('body');
              }
              notificationContainer.appendChild(notification);
            } else if (theme.settings.afterAddToCart === 'drawer') {
              document.querySelector('.js-cart-drawer').open();
            }
          }
        
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              variantId: data.variant_id
            }
          }));
        
          // Re-enable 'Add to Cart' button.
          this.submitBtn.classList.add('is-success');
          this.submitBtn.classList.add('is-added');
          this.submitBtn.removeAttribute('aria-disabled');
          setTimeout(() => {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
            this.submitBtn.classList.remove('is-added');
          }, 2000);
        } catch (error) {
          console.log(error); // eslint-disable-line
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg.textContent
            }
          }));
        
          // Re-enable 'Add to Cart' button.
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
          this.submitBtn.removeAttribute('aria-disabled');
        }

        
      }else{
        console.log('not proper');
      }
    }

    changeProductOption(evt){
      const isAvailable = false;
      this.submitBtn.classList.remove('is-error');
      this.submitBtn.classList.remove('no-stock');
      if(evt.target.disabled == true){
        console.log('outofstock');
        this.submitBtn.disabled = true;
        this.submitBtn.querySelector('.add-to-cart-text').innerText = this.submitBtn.dataset.noStock;
        this.submitBtn.classList.add('no-stock');
      }else{
        this.submitBtn.disabled = false;
        this.submitBtn.querySelector('.add-to-cart-text').innerText = this.submitBtn.dataset.addText;
      }

      this.outfitProducts.forEach((el) => {
        const product = [];
        if(el.querySelector('[name="id"]').disabled == true){
          this.submitBtn.disabled = true;
          this.submitBtn.querySelector('.add-to-cart-text').innerText = this.submitBtn.dataset.noStock;
        }
      });
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;
  
      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }

    validateProducts(){
      this.productSelected = [];
      
      this.outfitProducts.forEach((el) => {
        const product = [];
        if(!el.querySelector('.js-product').classList.contains('soldout-product')){
          if(el.querySelector('[name="id"]').disabled == true || el.querySelector('[name="id"]').value == ''){
              el.querySelectorAll('.option-selector').forEach((optionSelector) => {
                if(optionSelector.querySelector('input:checked') == null && el.querySelector('[name="id"]').value == ''){
                  optionSelector.querySelector('.error-wrapper').classList.remove('hidden');
                  optionSelector.querySelector('.error-msg').innerText = `Please select the ${optionSelector.dataset.option} option`;
                }else{
                  optionSelector.querySelector('.error-wrapper').classList.add('hidden');
                  optionSelector.querySelector('.error-msg').innerText = ``;
                }
              });
              this.submitBtn.classList.add('is-error');
              this.submitBtn.querySelector('.add-to-cart-text').innerText = 'Please selection option';          
            return false;
          }else{
            this.productSelected.push({
              id: el.querySelector('[name="id"]').value,
              quantity: el.querySelector('[name="quantity"]').value
            });
          }
        }
      });
      return true;
    }
    
  }
  
  customElements.define('outfit-products', OutfitProducts);
}